import React from 'react';
import { Package, Shapes, Ruler } from 'lucide-react';
import { theme } from '../../styles/theme';

interface CurrentPartCardProps {
  part: {
    part_id: string;
    part_number: string;
    shape: string;
    existing_dimensions_count: number;
  };
}

const SHAPE_COLORS: Record<string, string> = {
  TUBE: 'text-interactive-primary bg-interactive-primary/10',
  CUBOID: 'text-text-secondary bg-bg-subtle',
  DN: 'text-qc-success bg-qc-success/10',
  UNKNOWN: 'text-text-secondary bg-bg-subtle',
};

export const CurrentPartCard: React.FC<CurrentPartCardProps> = ({ part }) => {
  const shapeColor = SHAPE_COLORS[part.shape] || SHAPE_COLORS.UNKNOWN;
  
  return (
    <div className="bg-bg-subtle border border-border rounded-xl p-4">
      <div className="flex items-center gap-2 mb-3">
        <Package className="w-5 h-5 text-text-secondary" />
        <h3 className={`text-sm font-semibold ${theme.text.primary}`}>
          Current Part
        </h3>
      </div>
      
      <div className="space-y-2">
        {/* Part Number */}
        <div className="flex items-center justify-between">
          <span className={`text-xs ${theme.text.tertiary}`}>Part:</span>
          <span className={`text-sm font-mono font-medium ${theme.text.primary}`}>
            {part.part_number}
          </span>
        </div>
        
        {/* Shape */}
        <div className="flex items-center justify-between">
          <span className={`text-xs ${theme.text.tertiary}`}>Shape:</span>
          <span className={`text-sm font-medium px-2 py-0.5 rounded-full ${shapeColor}`}>
            <Shapes className="w-3 h-3 inline mr-1" />
            {part.shape}
          </span>
        </div>
        
        {/* Existing Dimensions Count */}
        <div className="flex items-center justify-between">
          <span className={`text-xs ${theme.text.tertiary}`}>Existing dimensions:</span>
          <span className={`text-sm font-semibold ${theme.text.primary}`}>
            <Ruler className="w-3 h-3 inline mr-1" />
            {part.existing_dimensions_count}
          </span>
        </div>
        
        {/* Part ID (collapsed, smaller) */}
        <details className="text-xs">
          <summary className={`cursor-pointer ${theme.text.tertiary} hover:${theme.text.secondary}`}>
            Part ID
          </summary>
          <code className={`block mt-1 p-2 bg-bg-base rounded text-xs ${theme.text.tertiary} overflow-x-auto`}>
            {part.part_id}
          </code>
        </details>
      </div>
    </div>
  );
};
